module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"headerTooltip":"Zakupione produkty producenta w wybranym zakresie czasu we wszystkich sklepach (wyświetlanych, niewyświetlanych)"}}')
  delete Component.options._Ctor
}
